import { useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import logo from '../images/logo.jpg';
import es from '../images/ar.png';
import en from '../images/en.png';
import ec from '../images/fr.png';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchText, setSearchText] = useState('');

  const getObjectFromPathname = () => {
    const pathname = location.pathname;
    const match = pathname.split('/')[1];
    return match;
  };

  const isActive = (_pageObject_) => {
    const _object_ = getObjectFromPathname();
    return _object_ === _pageObject_ ? 'active' : '';
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchText.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchText.trim())}`);
      setIsSearchOpen(false);
      setSearchText('');
    }
  };

  const handleSearchIconClick = () => {
    setIsSearchOpen(!isSearchOpen);
    setSearchText('');
  };

  // Language switcher - auto translation
  const switchLanguage = (lang) => {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    const rootDomain = parts.length > 1 ? '.' + parts.slice(-2).join('.') : hostname;

    const setCookie = (name, value) => {
      document.cookie = `${name}=${value}; path=/;`;
      document.cookie = `${name}=${value}; path=/; domain=${hostname};`;
      if (rootDomain !== hostname) {
        document.cookie = `${name}=${value}; path=/; domain=${rootDomain};`;
      }
    };

    setCookie('googtrans', `/auto/${lang}`);
    sessionStorage.setItem('site_lang', lang);
    localStorage.setItem('site_lang', lang);

    const select = document.querySelector('.goog-te-combo');
    if (select) {
      select.value = lang;
      select.dispatchEvent(new Event('change'));
    }

    window.location.reload();
  };

  return (
    <header id="header" className="header sticky-top">
      <div className="container position-relative d-flex align-items-center justify-content-end">
        {/* Logo */}
        <div className="logo-block">
          <a href="/"><img src={logo} alt="Whoisin Barcelona Logo" /></a>
        </div>

        <div className="rt-block ms-auto">
          {/* Top social & search */}
          <div className="top-block d-flex justify-content-end">
            <div className="socila-media">
              <ul className="d-flex">
                <li>
                  <a href="https://x.com/whoisinbcn" target="_blank" rel="noopener noreferrer">
                    <i className="fa-brands fa-x-twitter"></i>
                  </a>
                </li>
              </ul>
            </div>

            <div className="search">
              <a 
                href="#search" 
                role="button" 
                aria-label="Search"
                onClick={(e) => {
                  e.preventDefault();
                  handleSearchIconClick();
                }}
              >
                <i className={`fa ${isSearchOpen ? 'fa-times' : 'fa-search'}`}></i>
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div className="bottom-block d-flex justify-content-end align-items-center">
            <div className="navigation">
              <div id="nav-wrap">
                <ul className="sf-menu">
                  <li className={isActive('categories')}>
                    <a href="/categories">Categorías</a>
                  </li>
                  <li className={isActive('fiestas-mayor')}>
                    <a href="/maps-category/fiestas-mayors">Fiestas Mayor</a>
                  </li>
                  <li className={isActive('festivales')}>
                    <a href="/maps-category/festivales">Festivales</a>
                  </li>
                  <li className={isActive('agendas')}>
                    <a href="/agendas">Agenda</a>
                  </li>
                  <li className={isActive('subscriptions')}>
                    <a href="/subscriptions">Suscripciones</a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Language switch */}
            <div className="language-btn d-flex">
              <button 
                onClick={() => switchLanguage('es')}
                title="Español"
                style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
              >
                <img src={es} alt="Español" />
              </button>
              <button 
                onClick={() => switchLanguage('ca')}
                title="Català"
                style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
              >
                <img src={ec} alt="Català" />
              </button>
              <button 
                onClick={() => switchLanguage('en')}
                title="English"
                style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
              >
                <img src={en} alt="English" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Search Input Box */}
      {isSearchOpen && (
        <div className="search-bar position-absolute w-100 bg-white p-3 shadow" style={{ top: '100%', left: 0, zIndex: 1000 }}>
          <div className="container">
            <form onSubmit={handleSearchSubmit} className="d-flex">
              <input
                type="text"
                className="form-control me-2"
                placeholder="Search events, posts, categories..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                autoFocus
              />
              <button type="submit" className="btn btn-primary">Search</button>
            </form>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
